import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import Tags from './tags.jsx';
import UserText from '../../user_text.jsx';
import Reply from './note_reply.jsx';

export default class extends React.PureComponent {
    static propTypes = {
        replyTo: PropTypes.func.isRequired,
        answer: PropTypes.object,
        close: PropTypes.func.isRequired,
        markup: PropTypes.any.isRequired,
    };

    cancelSubmit = e => {
        e.preventDefault();
        e.stopPropagation();
    };

    renderTitleIcon = () => {
        const { answer } = this.props;
        const iClass = classnames({
            'is-question': true,
            'cl-icon': !!answer,
            'cl-icon-check': !!answer,
        });
        const title = classnames({
            Question: true,
            AnsweredQuestion: !!answer,
        });

        return (
            <i className={iClass} title={title} aria-hidden="true">
                <span className="aural">{title}</span>
            </i>
        );
    };

    renderAnswerForm = () => {};

    renderAnswer = () => {
        const { answer, markup, replyTo } = this.props;

        if (!answer) {
            return <Reply questionId={markup.id} replyTo={replyTo} />;
        }
        const created = moment(markup.created);
        const author_name = answer.author_name;

        return (
            <div className="note-content is-uneditable">
                <div className="metadata">
                    {author_name} replied
                    <time className="metadata" dateTime={created.toISOString()}>
                        {created.fromNow()}
                    </time>
                </div>

                <UserText element="div" className="note-text">
                    {answer.note_text}
                </UserText>
            </div>
        );
    };

    render() {
        const markup = this.props.markup;
        const created = moment(markup.created);

        return (
            <div className={classnames('question', markup.color)}>
                <header>
                    {this.renderTitleIcon()}
                    {markup.author_name} asked
                    <time className="metadata" dateTime={created.toISOString()}>
                        {created.fromNow()}
                    </time>
                    <button onClick={this.props.close} className="close">
                        &times;
                    </button>
                </header>

                <div
                    data-container="note"
                    className="clearfix note-content is-uneditable"
                >
                    <UserText>{markup.note_text}</UserText>

                    <Tags tags={markup.tags} />
                </div>

                <footer className="js-reply-content">
                    {this.renderAnswer()}
                </footer>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/text_viewer/highlight/question.ui.jsx